import { c as _c } from "react/compiler-runtime";
import React from 'react';
import usePDPUpSellCart from 'data-hooks/usePDPUpSellCart';
import usePDPAddUpSellProductEvent from 'data-hooks/useEvents/usePDPAddUpSellProductEvent';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import useCart from 'data-hooks/useCart';
import PDPUpSellProductUI from './PDPUpSellProductUI';
import usePDPOptions from '../state/context/usePDPOptions';
const PDPUpSellProductInner = () => {
  const $ = _c(12);
  const {
    data: t0,
    actions: t1
  } = useCart();
  const {
    addingToCart
  } = t0;
  const {
    addToCart,
    getCart
  } = t1;
  const {
    data: t2
  } = usePDPUpSellCart();
  const {
    hideUpSell,
    optionPrice,
    priceDetails,
    upSellImgFallbackUrl,
    upSellImgUrl,
    upSellProduct,
    upSellProductLink
  } = t2;
  const {
    data: optionData
  } = usePDPOptions();
  const addUpSellProductEvent = usePDPAddUpSellProductEvent();
  if (hideUpSell) {
    return null;
  }
  let t3;
  if ($[0] !== addToCart || $[1] !== addUpSellProductEvent || $[2] !== addingToCart || $[3] !== getCart || $[4] !== optionData.selectedOptions || $[5] !== optionPrice || $[6] !== priceDetails || $[7] !== upSellImgFallbackUrl || $[8] !== upSellImgUrl || $[9] !== upSellProduct || $[10] !== upSellProductLink) {
    t3 = <PDPUpSellProductUI addingToCart={addingToCart} addToCart={addToCart} addUpSellProductEvent={addUpSellProductEvent} getCart={getCart} optionPrice={optionPrice} parentProductSelectedOptions={optionData.selectedOptions} priceDetails={priceDetails} upSellImgFallbackUrl={upSellImgFallbackUrl} upSellImgUrl={upSellImgUrl} upSellProduct={upSellProduct} upSellProductLink={upSellProductLink} />;
    $[0] = addToCart;
    $[1] = addUpSellProductEvent;
    $[2] = addingToCart;
    $[3] = getCart;
    $[4] = optionData.selectedOptions;
    $[5] = optionPrice;
    $[6] = priceDetails;
    $[7] = upSellImgFallbackUrl;
    $[8] = upSellImgUrl;
    $[9] = upSellProduct;
    $[10] = upSellProductLink;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
const PDPUpSellProduct = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SuspenseWithLoader><PDPUpSellProductInner /></SuspenseWithLoader>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default PDPUpSellProduct;